import { createAsyncThunk } from "@reduxjs/toolkit";

import { CustomAction } from "../../../store/customAction";
import { API_POST_CUSTOMER_AGENTS } from "../../../Apis/ApiEndPoints";
import { Api } from "../../..";
import {
  IGetCustomerAgents,
  IGetCustomerAgentsResponse,
} from "./AgentDetails.types";

export const getAgents = createAsyncThunk(
  "dashboard/customer/agents",
  async (requestBody: IGetCustomerAgents, { dispatch }) => {
    const response: IGetCustomerAgentsResponse = await CustomAction(
      Api.post(API_POST_CUSTOMER_AGENTS, requestBody),
      dispatch,
      "dashboard/customer/agents"
    );
    return response;
  }
);
